//working but need to chnage colour
// // components/About.jsx
import React from "react";
import { Award, Zap, Users } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            About Hexa Electronics
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pioneering dairy technology solutions in Nepal with innovation,
            quality, and customer satisfaction at our core.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Feature Points */}
          <div>
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 p-3 rounded-lg mr-4">
                  <Award className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  ISO Certified Excellence
                </h3>
              </div>
              <p className="text-gray-600">
                We are proud to be the only company manufacturing milk analyzers
                in Nepal, maintaining the highest standards of quality and
                reliability through our ISO certification.
              </p>
            </div>

            <div className="mb-8">
              <div className="flex items-center mb-4">
                <div className="bg-green-100 p-3 rounded-lg mr-4">
                  <Zap className="w-6 h-6 text-green-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  Advanced Technology
                </h3>
              </div>
              <p className="text-gray-600">
                Our skilled professionals integrate advanced technology with
                user-friendly interfaces, continuously developing solutions for
                the evolving dairy sector.
              </p>
            </div>

            <div>
              <div className="flex items-center mb-4">
                <div className="bg-purple-100 p-3 rounded-lg mr-4">
                  <Users className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  Dedicated Research
                </h3>
              </div>
              <p className="text-gray-600">
                Our research team actively addresses real-world challenges with
                practical, sustainable solutions for dairy industry and
                livestock farmers.
              </p>
            </div>
          </div>

          {/* Right: Company Highlights */}
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Company Highlights
            </h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                <span className="text-gray-700">
                  Leading manufacturer of ultrasonic milk analyzers
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                <span className="text-gray-700">
                  Only milk analyzer manufacturer in Nepal
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                <span className="text-gray-700">
                  ISO-certified quality standards
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                <span className="text-gray-700">
                  Comprehensive dairy management software
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                <span className="text-gray-700">
                  Serving farms, cooperatives, and industries
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
// components/About.jsx
// components/About.jsx

// import React from "react";
// import { Award, Zap, Users } from "lucide-react";
// import { colors } from "../Color";

// export default function About() {
//   return (
//     <section
//       id="about"
//       className="py-20"
//       style={{ backgroundColor: colors.primary, color: colors.background }}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2
//             className="text-3xl md:text-4xl font-bold mb-4"
//             style={{ color: colors.background }}
//           >
//             About Hexa Electronics
//           </h2>
//           <p
//             className="text-xl max-w-3xl mx-auto"
//             style={{ color: colors.background }}
//           >
//             Pioneering dairy technology solutions in Nepal with innovation,
//             quality, and customer satisfaction at our core.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-12 items-center">
//           {/* Left: Feature Points */}
//           <div>
//             <div className="mb-8">
//               <div className="flex items-center mb-4">
//                 <div
//                   className="p-3 rounded-lg mr-4"
//                   style={{ backgroundColor: "rgba(255,255,255,0.2)" }} // semi-transparent white bg for icons
//                 >
//                   <Award
//                     className="w-6 h-6"
//                     style={{ color: colors.background }}
//                   />
//                 </div>
//                 <h3
//                   className="text-xl font-semibold"
//                   style={{ color: colors.background }}
//                 >
//                   ISO Certified Excellence
//                 </h3>
//               </div>
//               <p style={{ color: colors.background }}>
//                 We are proud to be the only company manufacturing milk analyzers
//                 in Nepal, maintaining the highest standards of quality and
//                 reliability through our ISO certification.
//               </p>
//             </div>

//             <div className="mb-8">
//               <div className="flex items-center mb-4">
//                 <div
//                   className="p-3 rounded-lg mr-4"
//                   style={{ backgroundColor: "rgba(255,255,255,0.2)" }}
//                 >
//                   <Zap
//                     className="w-6 h-6"
//                     style={{ color: colors.background }}
//                   />
//                 </div>
//                 <h3
//                   className="text-xl font-semibold"
//                   style={{ color: colors.background }}
//                 >
//                   Advanced Technology
//                 </h3>
//               </div>
//               <p style={{ color: colors.background }}>
//                 Our skilled professionals integrate advanced technology with
//                 user-friendly interfaces, continuously developing solutions for
//                 the evolving dairy sector.
//               </p>
//             </div>

//             <div>
//               <div className="flex items-center mb-4">
//                 <div
//                   className="p-3 rounded-lg mr-4"
//                   style={{ backgroundColor: "rgba(255,255,255,0.2)" }}
//                 >
//                   <Users
//                     className="w-6 h-6"
//                     style={{ color: colors.background }}
//                   />
//                 </div>
//                 <h3
//                   className="text-xl font-semibold"
//                   style={{ color: colors.background }}
//                 >
//                   Dedicated Research
//                 </h3>
//               </div>
//               <p style={{ color: colors.background }}>
//                 Our research team actively addresses real-world challenges with
//                 practical, sustainable solutions for dairy industry and
//                 livestock farmers.
//               </p>
//             </div>
//           </div>

//           {/* Right: Company Highlights */}
//           <div
//             className="p-8 rounded-2xl shadow-lg"
//             style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
//           >
//             <h3
//               className="text-2xl font-bold mb-6"
//               style={{ color: colors.background }}
//             >
//               Company Highlights
//             </h3>
//             <div className="space-y-4">
//               <div className="flex items-center">
//                 <div
//                   className="w-2 h-2 rounded-full mr-3"
//                   style={{ backgroundColor: colors.background }}
//                 ></div>
//                 <span style={{ color: colors.background }}>
//                   Leading manufacturer of ultrasonic milk analyzers
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <div
//                   className="w-2 h-2 rounded-full mr-3"
//                   style={{ backgroundColor: colors.background }}
//                 ></div>
//                 <span style={{ color: colors.background }}>
//                   Only milk analyzer manufacturer in Nepal
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <div
//                   className="w-2 h-2 rounded-full mr-3"
//                   style={{ backgroundColor: colors.background }}
//                 ></div>
//                 <span style={{ color: colors.background }}>
//                   ISO-certified quality standards
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <div
//                   className="w-2 h-2 rounded-full mr-3"
//                   style={{ backgroundColor: colors.background }}
//                 ></div>
//                 <span style={{ color: colors.background }}>
//                   Comprehensive dairy management software
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <div
//                   className="w-2 h-2 rounded-full mr-3"
//                   style={{ backgroundColor: colors.background }}
//                 ></div>
//                 <span style={{ color: colors.background }}>
//                   Serving farms, cooperatives, and industries
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
